module.exports = __webpack_public_path__ + "static/img/load.03e1a73.png";